<template>
    <div>
        <div class="sub-lnb-menu">
            <ul class="sub-lnb-menu__list">
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==1}" @click="lnbFn(1)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step1')">Услуги, предоставляемые в палате отделения интенсивной терапии, и меры предосторожности</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==2}" @click="lnbFn(2)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step2')">Предметы для приготовления</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==3}" @click="lnbFn(3)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step3')">Руководство по проведению обходов</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==4}" @click="lnbFn(4)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step4')">Информация о питании</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==5}" @click="lnbFn(5)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step5')">Руководство по посещениям и мерам предосторожности</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==6}" @click="lnbFn(6)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step6')">Прочее</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==7}" @click="lnbFn(7)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step7')">Список необходимых предметов при госпитализации в палату отделения интенсивной терапии</a>
                </li>
            </ul>
        </div>

        <div class="subSwiper info" v-if="$store.getters.getHost == 'H0006'">
            <swiper :cssMode="true" :navigation="{
					nextEl: '.subSwiper-next',
					prevEl: '.subSwiper-prev'
				}" :pagination="{ clickable: true }" :mousewheel="true" :keyboard="true" :modules="modules">
                <swiper-slide>
                    <img src="/resource/img/info-img02.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/info-img03.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/info-img04.jpg" alt="">
                </swiper-slide>
            </swiper>
            <div class="subSwiper-bth subSwiper-next"></div>
            <div class="subSwiper-bth subSwiper-prev"></div>
        </div>

        <!-- 뇌혈관 -->
        <div class="subSwiper info" v-else>
            <swiper :cssMode="true" :pagination="{ clickable: true }" :mousewheel="true" :keyboard="true" :modules="modules">
                <swiper-slide>
                    <img src="/resource/img/intensive01-brain.jpg" alt="">
                </swiper-slide>
            </swiper>
        </div>

        <div id="step1" class="step-item info">
            <h3 class="bullet01">Услуги, предоставляемые в палате отделения интенсивной терапии, и меры предосторожности</h3>
            <p class="bullet04 num1 depth">
                Предоставляется базовый уход за больными, такой как всасывание, смена позы, частичное купание, помощь в мочеиспускание, контроль опорожнения кишечника и помощь в приеме пищи.
            </p>
            <p class="bullet04 num2 depth">
                Как позвонить в экстренных случаях: в случае чрезвычайной ситуации или, когда вам нужна помощь медсестры, нажмите на звонок экстренной помощи, прикрепленный к кровати, чтобы вызвать медсестру, и вы немедленно получите помощь.
            </p>
            <p class="bullet04 num3 depth">
                В отделении интенсивной терапии может быть произведена смена палат для проведения инфекционного контроля и специального лечения в отделении интенсивной терапии.
            </p>
            <p class="bullet04 num4 depth">
                <span>
                    Для предотвращения технического обслуживания различных трубок (катетеров, дренажных трубок, кондуитов и т. д.) и медицинских устройств или оборудования, которые непосредственно воздействуют на дыхательную и сердечно-сосудистую системы пациента, таких как респираторы и аппараты искусственного кровообращения, а также причинения вреда себе и окружающим, 
                    <span class="font-main">может быть применено защитное средство для тела, </span> 
                    и процедура заключается в следующем.
                </span>
            </p>
            <p class="bullet05 depth">
                Необходимость использования защитного средства для тела разъясняется пациенту или опекуну лечащим врачом, и область применения осматривается не реже, чем каждые 2 часа.
            </p>
            <p class="bullet05 depth">
                В зависимости от экстренной ситуации медицинский персонал может сначала применить его, а затем объяснить опекуну.
            </p>
            <p class="bullet04 num5 depth">
                Пожалуйста, сообщите лечащему врачу и медсестре о лекарствах, которые пациент взял с собой перед госпитализацией. Лекарства, которые пациент взял с собой перед госпитализацией, нельзя принимать произвольно.
            </p>
        </div>
        <div id="step2" class="step-item info">
            <h3 class="bullet01">Предметы для приготовления</h3>
            <p class=" depth">Пожалуйста, приготовьте влажные салфетки, подгузники, коврики и маски, которые будут использоваться пациентом.</p>
        </div>
        <div id="step3" class="step-item info">
            <h3 class="bullet01">Руководство по проведению обходов</h3>
            <p class="bullet04 num1 depth">Обходы проводятся в 8.00-10.00 и могут варьироваться в зависимости от условий отделения.</p>
            <p class="bullet04 num2 depth">Если вы хотите пройти собеседование во время обхода, пожалуйста, сообщите об этом лечащей медсестре.</p>
        </div>
        <div id="step4" class="step-item info">
            <h3 class="bullet01">Информация о питании</h3>
            <p class="bullet04 num1 depth">Время приема пищи для пациентов, которые могут принимать пищу – завтрак: в 7.00-8.00, обед: в 12.00-13.00, ужин: в 18.00-19.00.</p>
            <p class="bullet04 num2 depth">По желанию пациента он может выбрать «специальное питание», которое не покрывается страховым полисом, и в этом случае пациент оплачивает полную стоимость.</p>
        </div>
        <div id="step5" class="step-item info">
            <h3 class="bullet01">Руководство по посещениям и мерам предосторожности</h3>
            <p class="bullet04 num1 depth">Обычные время посещения</p>
            <div class="table mt20 ">
                <div class="table__inner">
                    <table>
                        <colgroup>
                            <col style="width:25%;">
                            <col style="width:25%;">
                            <col style="width:25%;">
                            <col style="width:25%;">
                        </colgroup>
                        <thead>
                            <tr>
                                <th colspan="2">Отделение</th>
                                <th>День недели</th>
                                <th>Время</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td rowspan="2">Интегрированное отделение интенсивной терапии</td>
                                <td>Неврологическое отделение интенсивной терапии</td>
                                <td>Каждый день</td>
                                <td rowspan="4">13.00-13.20</td>
                            </tr>
                            <tr>
                                <td>Терапевтическое отделение интенсивной терапии </td>
                                <td>Каждый день</td>
                            </tr>
                            <tr>
                                <td rowspan="2">Хирургическое отделение интенсивной терапии</td>
                                <td>Хирургическое отделение интенсивной терапии</td>
                                <td>Каждый день</td>
                            </tr>
                            <tr>
                                <td>Отделение интенсивной терапии сердечно-сосудистой системы</td>
                                <td>Каждый день</td>
                            </tr>
                            <tr>
                                <td>Отделение интенсивной терапии аортально-сосудистой системы</td>
                                <td>Отделение интенсивной терапии аортально-сосудистой системы</td>
                                <td>Каждый день</td>
                                <td>12:30 ~ 12:50</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <p class="bullet04 num2 depth mt20">
                Посещение может быть ограничено или отложено в зависимости от ситуации в палате отделения интенсивной терапии.
            </p>
            <p class="bullet04 num3 depth">
                В целях инфекционного контроля количество посетителей ограничено 1 человеком, и его нельзя заменить.
            </p>
            <p class="bullet04 num4 depth">
                В целях стабилизации состояния пациента и профилактики инфекций посещение детей в возрасте до 12 лет со слабой иммунной системой или членов семьи, страдающих простудными или инфекционными заболеваниями, ограничено, и необходимо соблюдать время посещения.
            </p>
            <p class="bullet04 num5 depth">
                До и после посещения, пожалуйста, используйте дезинфицирующее средство для рук или вымойте руки в раковине у входа в палате отделения интенсивной терапии.
            </p>
            <p class="bullet04 num6 depth">
                При посещении, пожалуйста, надевайте пластиковый халат, который выдают при входе в палате отделения интенсивной терапии, а перед выходом из палаты отделения интенсивной терапии, пожалуйста, снимите пластиковый халат, вымойте руки и уходите.
            </p>
            <p class="bullet04 num7 depth">
                Во избежание падений во время посещения, пожалуйста, соблюдайте следующее:
            </p>
            <p class="bullet05 depth">Всегда поднимайте обе перекладины кровати.</p>
            <p class="bullet05 depth">Если вам нужна помощь, пожалуйста, позвоните или вызовите медсестру по телефону.</p>
            <p class="bullet04 num8 depth">
                В палате отделения интенсивной терапии необходимо выключать мобильные телефоны, так как радиопомехи могут привести к сбоям в работе медицинского оборудования.
            </p>
            <p class="bullet04 num9 depth">
                Если вы заметили какие-либо ненормальные признаки (изменения сознания, боль в груди, кровотечение, судороги, болевые ощущения и т. д.) у пациента во время посещения, пожалуйста, немедленно сообщите об этом медицинскому персоналу.
            </p>
            <p class="bullet04 num10 depth">
                Для педиатрических пациентов во время посещения могут проводиться процедуры идентификации, чтобы предотвратить похищение и обеспечить безопасность.
            </p>
            <p class="bullet04 num11 depth">
                Пожалуйста, помогите составить список посетителей для управления посетителями.
            </p>
        </div>

        <div id="step6" class="step-item info">
            <h3 class="bullet01">Прочее</h3>
            <h4 class="bullet02 type2 num1 depth">Удобства</h4>
            <p class="depth">
                Имеются автоматическое платежное устройство медицинских расходов, регистратор компакт-дисков с радиологическими файлами, круглосуточный магазин, банк, кафе, фуд-корт, пекарня, магазин медицинских приборов, автоматический ящик для посылок, и т. д.
            </p>

            <h4 class="bullet02 type2 num2 depth">Меры предотвращения пожаров и ликвидации их последствий</h4>
            <p class="depth">
                Пожалуйста, воздержитесь от использования переносных газовых плит, электрических вентиляторов, электрообогревателей и проноса легковоспламеняющихся материалов в зале ожидания для семьи. В случае пожара незамедлительно сообщите об этом персоналу госпиталя и эвакуируйтесь через эвакуационную комнату и аварийную лестницу в соответствии с указаниями персонала госпиталя.
            </p>

            <h4 class="bullet02 type2 num3 depth">Запрет курения</h4>
            <p class="depth">
                В целях охраны здоровья пациентов и предотвращения пожаров вся госпиталь является зоной для некурящих, поэтому, пожалуйста, примите меры по прекращению курения.
            </p>

            <h4 class="bullet02 type2 num4 depth">Рассмотрение жалоб и недовольства</h4>
            <p class="depth">
                Если у вас возникнут какие-либо вопросы, неудобства или пожелания во время пребывания в больнице, вы можете посетить офис по работе с клиентами на 1-м этаже, позвонить, воспользоваться веб-сайтом госпиталя.
            </p>

            <h4 class="bullet02 type2 num5 depth">Плата за парковку</h4>
            <p class="depth">
                Пожалуйста, ознакомьтесь с информацией о плате за парковку, размещенной на доске объявлений палаты.
            </p>

            <h4 class="bullet02 type2 num6 depth">Остерегайтесь потери или кражи</h4>
            <p class="depth">
                Нельзя хранить ценные вещи и наличные деньги в палате отделения интенсивной терапии. Храните их в своем личном сейфе или обратитесь в администрации госпиталя. Пожалуйста, соблюдайте осторожность при хранении вспомогательных приспособлений, таких как зубные протезы, слуховые аппараты, очки и контактные линзы, поскольку их необходимо снимать во время обследований, процедур, хирургических вмешательств и в чрезвычайных ситуациях. Госпиталь не несет ответственности за убытки, вызванные вашей собственной небрежностью.
            </p>

            <h4 class="bullet02 type2 num7 depth">Управление имуществом </h4>
            <ul class="bullet-list type2 depth">
                <li class="bullet-item">очки </li>
                <li class="bullet-item">зубные протезы </li>
                <li class="bullet-item">слуховые аппараты </li>
                <li class="bullet-item">бумажник </li>
                <li class="bullet-item">мобильный телефон </li>
                <li class="bullet-item">одежда </li>
                <li class="bullet-item">обувь </li>
                <li class="bullet-item">ключи </li>
                <li class="bullet-item">часы </li>
                <li class="bullet-item">серьги </li>
                <li class="bullet-item">ожерелье </li>
                <li class="bullet-item">кольцо </li>
                <li class="bullet-item">браслет </li>
                <li class="bullet-item">кольцо  </li>
                <li class="bullet-item">другие ( <span class="gap50"></span> )были доставлены человеку (имя: <span class="gap100"></span>отношение: <span class="gap100"></span>)</li>
            </ul>


            <h4 class="bullet02 type2 num8 depth">Информация о религиозных объектах</h4>
            <p class="depth">
                Эта госпиталь является христианской больницей, и воскресные службы проводятся в 10.00 по воскресеньям, службы по средам – в 17.00, а детские/молодежные службы проводятся в 10.00 по четвергам в церкви Банджу на 3-м этаже здания С. Для получения дополнительной информации о посещении приходов, получения консультаций по вопросам веры и другим религиозным вопросам, пожалуйста, звоните в кабинет пастырских консультаций (02-6986-5724). Кабинет пастырских консультаций и молитвенная комната расположены на 3-м этаже корпуса С.
            </p>

            <h4 class="bullet02 type2 num9 depth">Руководство по процедуре выписки</h4>
            <p class="depth">
                После рассмотрения страхового полиса при выписке пациенту или опекуну будет отправлено текстовое сообщение. Для оплаты при выписке, пожалуйста, воспользуйтесь окошком приема/выписки администрации госпиталя или автоматическим платежным устройством. После оплаты вы можете получить лекарства при выписке в кабинете медсестры.
            </p>

            <h4 class="bullet02 type2 num10 depth">Выдача различных справок</h4>
            <p class="depth">
                Пожалуйста, заранее сообщите лечащему врачу или медсестре обо всех необходимых документах, таких как сертификат о диагнозе, медицинские записи и видеозаписи и т. д.
            </p>

            <h4 class="bullet02 type2 num11 depth">Мы уважаем и защищаем права и обязанности пациента на протяжении всего процесса лечения.</h4>
            <div class="table mt20">
                <div class="table__inner">
                    <table>
                        <colgroup>
                            <col style="width:50%;">
                            <col style="width:50%;">
                        </colgroup>
                        <thead>
                            <tr>
                                <th>Права пациента</th>
                                <th>Обязанности пациента</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num1">Право на получение медицинской помощи</p>
                                </td>
                                <td class="left" rowspan="2">
                                    <p class="bullet04 num1">Обязательство доверять медицинскому персоналу и уважать его</p>
                                </td>
                            </tr>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num2">Право знать и право на самоопределение</p>
                                </td>
                            </tr>


                            <tr>
                                <td class="left">
                                    <p class="bullet04 num3">Право на конфиденциальность</p>
                                </td>
                                <td class="left" rowspan="3">
                                    <p class="bullet04 num2">Обязательство не осуществлять лечение ненадлежащим образом</p>
                                </td>
                            </tr>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num4">Право обращаться за консультацией и посредничеством</p>
                                </td>
                            </tr>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num5">Право на получение медицинских услуг в безопасных медицинских условиях</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <h4 class="bullet02 type2 num12 depth mt20">
                Если пациент или опекун (посетитель) причиняет ущерб сотруднику посредством насилия (словесные оскорбления, угрозы, массовые беспорядки, сексуальное насилие, сексуальные домогательства, порча имущества и т. д.), это может быть наказано в соответствии с соответствующими законами и нормативными актами.
            </h4>

            <h4 class="bullet02 type2 num13 depth mt20">
                Если пациент, опекун и т. д. создают ситуацию, которая может представлять собой оскорбление, диффамацию, физическое нападение или воспрепятствование деятельности соответствующего медицинского работника, тем самым препятствуя выполнению медицинским работником обычных медицинских процедур, в лечении может быть отказано (право на отказ от лечения) в пределах, не нарушающих Закон о медицинской службе или Закон о неотложной медицинской помощи.
            </h4>

            <h4 class="bullet02 type2 num14 depth mt20">
                В период госпитализации за состоянием пациента будет вестись наблюдение с помощью системы видеонаблюдения, но запись производиться не будет.
            </h4>

        </div>

        <div id="step7" class="step-item info">
            <h3 class="bullet01">Список необходимых предметов при госпитализации в палату отделения интенсивной терапии</h3>

            <h4 class="bullet02 depth">Руководство по посещениям в палату отделения интенсивной терапии</h4>
            <p class="depth">Обычные часы посещения в палату отделения интенсивной терапии: каждый день  <span class="font-main">(12:30~12:50)</span></p>

            <h4 class="bullet02 depth">Руководство по переводу из отделения интенсивной терапии в общую палату</h4>
            <p class="depth">
                При переводе из палаты отделения интенсивной терапии в общую палату требуется сиделка или опекун, который может обеспечить круглосуточный уход. Пациентам, которые могут передвигаться, пожалуйста, приготовьте тапочки.
            </p>

            <h4 class="bullet02 depth">Дополнительная информация</h4>
            <p class="depth">
                Пожалуйста, имейте в виду, что в случае поступления пациента для неотложной помощи он может быть переведен экстренно в палату другого отделения независимо от времени и от решения отделения.
            </p>

            <h4 class="bullet02 depth">Предметы, необходимые в палате отделения интенсивной терапии</h4>
            <div class="need-item">
                <div class="need-item__text">
                    <p class="bullet04 num1 depth">Медикаменты, имеющие перед госпитализацией (за исключением лекарств, отпускаемых в нашем госпитале)</p>
                    <p class="bullet04 num2 depth">Подгузники (типа крылышки O, типа трусики X)</p>
                    <p class="bullet04 num3 depth">Коврик, влажная салфетка (большого размера)</p>
                    <p class="bullet04 num4 depth">Вазелин для губ</p>
                    <p class="bullet04 num5 depth">Бумажный стаканчик, 500 мл воды*2 (при необходимости)</p>
                    <p class="bullet04 num6 depth">Для пациентов, находящихся в сознании: зубная щетка, зубная паста, стакан для воды с трубочкой, салфетка в коробке</p>


                    <!-- <p class="bullet04 num7 depth"><span><span class="font-main">수술 후 환자의 경우</span>(필요시):트리플로우(호흡기치료기)*1</span></p>
                    <p class="bullet05 depth">지하1층 의료기상사에서 구입가능</p> -->
                </div>
                <div class="need-item__img">
                    <img src="@/assets/resource/img/needitem.png" alt="">
                </div>
            </div>

            <h4 class="bullet02 depth">Информация о том, что в палате отделения интенсивной терапии нельзя хранить ценные вещи</h4>
            <p class="depth">
                В отделение интенсивной терапии нельзя пользоваться личным мобильным телефоном. Мы не несем ответственности за утерянные ценные вещи, поэтому, пожалуйста, возьмите их с собой обратно. Пожалуйста, сообщите нам, если вы носите зубные протезы / слуховые аппараты. 
            </p>

            <h4 class="bullet02 depth">Места, где можно приобрести необходимые вещи</h4>
            <p class="bullet03 depth">24 часа: <span class="font-main">круглосуточный магазин CU на цокольном этаже B1</span></p>
            <p class="bullet03 depth">Пн-Пт, 09-18 :<span class="font-main">магазин медицинских приборов на цокольном этаже B1</span></p>
        </div>

    </div>
</template>
<script>
    // Import Swiper Vue.js components
    import { Swiper, SwiperSlide } from 'swiper/vue';

    // Import Swiper styles
    import 'swiper/css';

    import 'swiper/css/navigation';
    import 'swiper/css/pagination';

    import { Navigation, Pagination, Mousewheel, Keyboard } from 'swiper/modules';

    export default {
        components: {
            Swiper,
            SwiperSlide,
        },
        setup() {
            return {
                modules: [Navigation, Pagination, Mousewheel, Keyboard],
            };
        },
        data() {
            return {
                lnbIndex: 1,
            };
        },
        mounted() {
            window.addEventListener('scroll', this.handleScroll);
        },
        methods: {
            scrollTo(id) {
                const element = document.getElementById(id);
                if (element) {
                    // 해당 요소의 위치와 크기 정보 가져오기
                    const elementTop = element.getBoundingClientRect().top + window.pageYOffset;

                    // 스크롤을 이동할 위치를 계산 (100px 추가)
                    const scrollToPosition = elementTop - 100;

                    // 계산된 위치로 부드럽게 스크롤
                    window.scrollTo({
                    top: scrollToPosition,
                    behavior: 'smooth'
                    });
                }
            },
            handleScroll() {
                const sections = document.querySelectorAll('.step-item');
                sections.forEach((section, index) => {
                    const rect = section.getBoundingClientRect();
                    // Check if the top of the section is within the viewport
                    if (rect.top <= 101 && rect.top <= window.innerHeight) {
                        this.lnbIndex = index + 1; // Update lnbIndex based on the section's position
                    }
                });
            },
            lnbFn(index) {
                this.lnbIndex = index; // Change the active index when clicking the menu
            },
        },
    };
</script>